import { Box, Hint } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface INavigateThroughWeeksHintProps {
  stepNumber: number
}

const NavigateThroughWeeksHint = ({ stepNumber }: INavigateThroughWeeksHintProps) => {
  return (
    <Box paddingLeft="s200">
      <Hint.Popover
        step={stepNumber}
        title={i18n.t('project_management.my_projects.hints.navigate_through_weeks.title')}
        description={i18n.t(
          'project_management.my_projects.hints.navigate_through_weeks.description'
        )}
        actionLabel={i18n.t(
          'project_management.my_projects.hints.navigate_through_weeks.action_label'
        )}
        position="bottom right"
      />
    </Box>
  )
}

export default observer(NavigateThroughWeeksHint)
